
import { useState } from 'react';
import { Navbar } from '../platform/components/Navbar';
import { Footer } from '../platform/components/Footer';
import { ProductGrid } from './components/ProductGrid';
import { FilterSidebar } from './components/FilterSidebar';
import { SearchBar } from './components/SearchBar';

export default function ProductsPage() {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedRegion, setSelectedRegion] = useState<string>('all');
  const [priceRange, setPriceRange] = useState<string>('all');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50/40 via-orange-50/20 to-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e56263bde52f97fec225ea948c79677b.jpg"
            alt="석양 항구"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-6">
            <i className="ri-ship-line text-amber-300"></i>
            <span className="text-sm text-amber-100 font-medium">만선허브 제품 카탈로그</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg">
            제품 카탈로그
          </h1>
          <p className="text-xl text-amber-100/90 max-w-2xl mx-auto drop-shadow-md">
            전국 우수 제조업체의 어구, 갑판용품, 기관물품을 한눈에 비교하고 선택하세요
          </p>
        </div>
      </section>

      {/* Search Bar */}
      <div className="bg-white/80 backdrop-blur-md border-b border-amber-200/50 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
          <SearchBar 
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Filter Sidebar */}
          <aside className="lg:w-72 flex-shrink-0">
            <FilterSidebar
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              selectedRegion={selectedRegion}
              setSelectedRegion={setSelectedRegion}
              priceRange={priceRange}
              setPriceRange={setPriceRange}
            />
          </aside>

          {/* Product Grid */}
          <main className="flex-1">
            <ProductGrid
              selectedCategory={selectedCategory}
              selectedRegion={selectedRegion}
              priceRange={priceRange}
              searchQuery={searchQuery}
              viewMode={viewMode}
            />
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
}
